import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { Appraisal, IAppraisal } from "@/models/appraisal.entity";

export const AppraisalDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IAppraisal> {
  getIdentifier(entity: IAppraisal): string {
    return entity.id;
  }

  protected mapEntity(entity: IAppraisal): IAppraisal {
    return new Appraisal(entity);
  }
})();
